import '../deps/SM';
import Auth from '../deps/login/index';

const platform = Uplib.native.getPlatform();

const cache = UpSDK.cache;

let defaultCfg = {
    oauthtype: ''
}

const h5login = Object.assign({
	init() {
		// 若是客户端
		if (platform == 'uplive') {
			Uplib.native.getConfigs({
                invalid: 0,
                complete: function(cfg) {
                    let userToken = cfg.usertoken;
                    let uid = cfg.uid;
                    
                    let user = {
                    	uid,
                    	userToken
                    }
                    
                   	UpSDK.writeLoginInfo(user);
                    UpSDK.emit('getUserSuccess', user);                    
                },
                errtip: function() {
                    // 不支持协议   
                }
            });
		} else {
			this.getSMDeviceId().done(() => {
	            let auth = new Auth({
	                oauthtype: defaultCfg.oauthtype
	            });

	            auth.init();
	        })
		}
    },

    getSMDeviceId(){
    	let defer = $.Deferred();
	    // 无论是否使用游客，都产生一个smd（数美的deviceId）
	    // 并且存储到本地
	    let cacheDeviceId = cache.getCache('smDeviceId');

	    if (!cacheDeviceId) {

	        // 数美JS已经加载完成
	        if (typeof SMSdk !== 'undefined') {
	            window.smDeviceId = SMSdk.getDeviceId();
	            cache.setCache('smDeviceId', window.smDeviceId);
	            defer.resolve();
	        } else {

	            // 否则监听事件，等待sdk加载完成
	            $.channel.on('smsdkLoaded', () => {
	                window.smDeviceId = SMSdk.getDeviceId();
	                cache.setCache('smDeviceId', smDeviceId);
	                defer.resolve();
	            });

	            $.channel.on('smsdkLoadedError', () => {
	                defer.resolve();
	            })
	        }
	    } else {
	        window.smDeviceId = cacheDeviceId;
	        defer.resolve();
	    }

	    return defer;
    }
}, Uplib.Events)


const _init = function(options) {
    options = options || {};

    defaultCfg = Object.assign(defaultCfg, options);

    h5login.init();
}

const login = function(cfg) {
    _init.apply(h5login, arguments);

    return h5login;
}

let bauthtype = cache.getCache('bizoauthtype');

if (bauthtype) {

	let oauthcode = Uplib.url.query('code') || Uplib.url.query('oauth_token');
	
	cache.removeCache('bizoauthtype');
	
	if (oauthcode) {
		login({
			oauthtype: bauthtype 
		})
	}
}

UpSDK.login = login;


// WEBPACK FOOTER //
// ./js/component/openjs/uph5/login.js